import { Badge, Button, Image, Tooltip } from 'antd';
import React, { useContext, useEffect, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import CustomContext from '../../context/CustomContext';
import autodeskIcon from '../../resources/images/autodesk.svg';
import autodeskService from '../../services/AutodeskService';
import notificationService from '../../services/NotificationService';
import styles from './AutodeskComponent.module.scss';

/**
 * Returns the autodesk component.
 * @returns the autodesk component.
 */
const AutodeskComponent = (): React.ReactElement => {
    /*** HOOKS ***/

    const intl = useIntl();
    const context = useContext(CustomContext);
    const { providerAuths } = context;
    const [active, setActive] = useState<boolean>(false);
    const [autodeskAllowed, setAutodeskAllowed] = useState<boolean>();

    /*** EFFECTS ***/

    useEffect(() => {
        const initialize = async () => {
            try {
                const autodeskAllowed = !!autodeskService.getCachedClientId();
                setAutodeskAllowed(autodeskAllowed);
                if (autodeskAllowed && providerAuths.includes('AUTODESK')) {
                    setActive(true);
                } else {
                    setActive(false);
                }
            } catch (error) {
                notificationService.displayError(error, intl);
            }
        };
        initialize();
    }, [intl, providerAuths]);

    /*** METHODS ***/

    const connect = async () => {
        try {
            const accessToken = await autodeskService.getAccessTokenOrLogin();
            setActive(!!accessToken);
        } catch (error) {
            notificationService.displayError(error, intl);
        }
    };

    /*** COMPONENTS ***/

    if (autodeskAllowed && active) {
        return (
            <Tooltip title={<FormattedMessage id="header.settings.autodesk.active.tooltip" />} className={styles.icon}>
                <Badge dot offset={[-3, 5]} color="green">
                    <Button
                        type="link"
                        icon={<Image src={autodeskIcon} preview={false} className={styles.autodesk} />}
                    />
                </Badge>
            </Tooltip>
        );
    } else if (autodeskAllowed && active === false) {
        return (
            <Tooltip
                title={<FormattedMessage id="header.settings.autodesk.inactive.tooltip" />}
                className={styles.icon}
            >
                <Badge dot offset={[-3, 5]}>
                    <Button
                        type="link"
                        icon={<Image src={autodeskIcon} preview={false} className={styles.autodesk} />}
                        onClick={connect}
                    />
                </Badge>
            </Tooltip>
        );
    } else {
        return <></>;
    }
};
export default AutodeskComponent;
